import { useEffect, useState } from "react";

/**
 * Uygulama tema modu: açık (varsayılan) / koyu.
 *
 * Tek kaynak: seçim localStorage'da tutulur, <html data-theme="..."> özniteliğine yazılır.
 * - CSS: marka token'larının koyu karşılıkları brand.css'te, bileşen istisnaları dark-theme.css'te
 *   ([data-theme="dark"] altında) — açık tema hiçbir kurala dokunmaz.
 * - antd: App.js useThemeMode ile getAntdTheme(mode) seçer; statik API'ler (Modal.confirm vb.) her
 *   çağrıda getThemeMode okur (bkz. antd-theme.js).
 * Varsayılan AÇIK: kullanıcı header'daki düğmeyle seçmedikçe görünüm değişmez (sistem tercihi izlenmez).
 */
const STORAGE_KEY = 'ris-theme-mode';
const CHANGE_EVENT = 'ris-theme-mode-change';

export const THEME_MODES = {
    LIGHT: 'light',
    DARK: 'dark',
};

export const getThemeMode = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) === THEME_MODES.DARK ? THEME_MODES.DARK : THEME_MODES.LIGHT;
    } catch {
        // Depolama kapalı (gizli pencere vb.): varsayılan açık.
        return THEME_MODES.LIGHT;
    }
};

/** Modu belgeye uygular. color-scheme: kaydırma çubukları ve yerel form kontrolleri de temaya uysun. */
export const applyThemeMode = (mode = getThemeMode()) => {
    const root = document.documentElement;
    root.setAttribute('data-theme', mode);
    root.style.colorScheme = mode;
};

export const setThemeMode = (mode) => {
    try {
        localStorage.setItem(STORAGE_KEY, mode);
    } catch {
        // Kaydedilemese de bu sekmede geçerli olsun.
    }
    applyThemeMode(mode);
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: mode }));
};

/** Güncel modu döner; bu sekmede ya da başka bir sekmede değişince yeniden render eder. */
export const useThemeMode = () => {
    const [mode, setMode] = useState(getThemeMode);

    useEffect(() => {
        const onChange = () => setMode(getThemeMode());
        const onStorage = (e) => {
            if (e.key !== STORAGE_KEY)
                return;
            applyThemeMode();
            onChange();
        };

        window.addEventListener(CHANGE_EVENT, onChange);
        window.addEventListener('storage', onStorage);
        return () => {
            window.removeEventListener(CHANGE_EVENT, onChange);
            window.removeEventListener('storage', onStorage);
        };
    }, []);

    return mode;
};
